import { render } from "./UserRole.vue?vue&type=template&id=7ff0a920&scoped=true"
import script from "./UserRole.vue?vue&type=script&lang=js"
export * from "./UserRole.vue?vue&type=script&lang=js"

import "./UserRole.vue?vue&type=style&index=0&id=7ff0a920&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff0a920"]])

export default __exports__